module.exports = __webpack_public_path__ + "assets/retina_EquilateralInCircleDetailed.9038cc64c830b0596c4952190e39f6dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_EquilateralInCircleDetailed.png
// module id = 665
// module chunks = 0